const ProductActionType = {
    PRODUCT_REQUEST:'PRODUCT_REQUEST',
    PRODUCT_SUCCESS:'PRODUCT_SUCCESS',
    PRODUCT_FAIL:'PRODUCT_FAIL',

    SINGLE_PRODUCT_REQUEST:'SINGLE_PRODUCT_REQUEST',
    SINGLE_PRODUCT_SUCCESS:'SINGLE_PRODUCT_SUCCESS',
    SINGLE_PRODUCT_FAIL:'SINGLE_PRODUCT_FAIL',
    
}


export default ProductActionType